import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'

export const mailing_edit = {

  namespaced: true,

  state: {
    values: {},
    entities: [],
  },

  getters: {
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setEntities(state, entities) { state.entities = entities },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Mailing'],
      form_display: true,
    }}),

    async getForm({ commit, dispatch }) {
      commit('setEntities', []);
      const entities = await dispatch('getEntities');
      commit('setProgress', false, { root: true });
      commit('setValues', getValues('mailing', entities.data['App\\Models\\Mailing'], 'content'));
      commit('setEntities', entities.data['App\\Models\\Mailing']);
    },

    async validateMailing({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Mailing', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        let values = prepareValues(state.values, state.entities, 'content_');
        dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Mailing', values);
      }
    },

    async createMailing({ commit }, values) {
      const response = await Vue.axios.post(API_URL + '/mailings', values);
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'mailing_successfully_created' }, { root: true });
      router.push('/mailing/' + response.data.id + '/edit');
    },

    async updateMailing({ commit }, values) { 
      const mailing = await Vue.axios.put(API_URL + '/mailings/' + router.currentRoute.params.id, values);
      commit('mailing/setPublish', mailing.data.publish, { root: true });
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'mailing_successfully_updated' }, { root: true });
    },

  }
}
